import { render, staticRenderFns } from "./TurbulenceJP.vue?vue&type=template&id=7fbe4c71"
import script from "./TurbulenceJP.vue?vue&type=script&lang=js"
export * from "./TurbulenceJP.vue?vue&type=script&lang=js"
import style0 from "./TurbulenceJP.vue?vue&type=style&index=0&id=7fbe4c71&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports